import React from "react"

export default function Info() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
			<path d="M10.0312 0.617188C4.51125 0.617188 0.03125 5.09719 0.03125 10.6172C0.03125 16.1372 4.51125 20.6172 10.0312 20.6172C15.5513 20.6172 20.0312 16.1372 20.0312 10.6172C20.0312 5.09719 15.5513 0.617188 10.0312 0.617188ZM10.0312 15.6172C9.48125 15.6172 9.03125 15.1672 9.03125 14.6172V10.6172C9.03125 10.0672 9.48125 9.61719 10.0312 9.61719C10.5813 9.61719 11.0312 10.0672 11.0312 10.6172V14.6172C11.0312 15.1672 10.5813 15.6172 10.0312 15.6172ZM11.0312 7.61719H9.03125V5.61719H11.0312V7.61719Z" fill="white" />
		</svg>
	)
}
